import { http } from './ApiService';

export default {
  getDetails: (id: number) => {
    return http.get(
      `/api/users/${id}`,
    );
  },
};
